__turbopack_context__.v({
  "content": "peopleCarousel-module-scss-module__aWqyYW__content",
  "function": "peopleCarousel-module-scss-module__aWqyYW__function",
  "image": "peopleCarousel-module-scss-module__aWqyYW__image",
  "name": "peopleCarousel-module-scss-module__aWqyYW__name",
  "person": "peopleCarousel-module-scss-module__aWqyYW__person",
  "personTile": "peopleCarousel-module-scss-module__aWqyYW__personTile",
  "quote": "peopleCarousel-module-scss-module__aWqyYW__quote",
});
